(function(){
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
  }
  waitForElm('.rc_widget .rc-selling-plans select.rc_widget__option__plans__dropdown').then((elm) => {
    elm.querySelector("option:nth-child(2)").selected = true;
    setTimeout(function(){
    waitForElm('.rc-option--subsave .rc_widget__option__label').then((subscribeLabelWrap) => {
      if (subscribeLabelWrap && !document.querySelector('.glove-club-text')) {
        const infoContainer = document.createElement('div');
        infoContainer.className = 'glove-club-text';
        infoContainer.style.marginTop = '10px';
        infoContainer.style.fontSize = '13px';
        infoContainer.style.lineHeight = '1.4';
        infoContainer.style.color = '#fff';
        infoContainer.style.opacity = '0.9';

        infoContainer.innerHTML = `
          <strong style="display:block;margin-bottom:5px;">Join the Glove Club:</strong>
          <ul style="padding-left: 18px; list-style: disc; margin: 0;">
            <li>Always 25% off.</li>
            <li>Early access to new glove drops.</li>
            <li>Free shipping—even on accessory add ons.</li>
            <li>Gift on every 3rd recurring order.</li>
            <li>Pause, skip, or cancel anytime—no hard feelings.</li>
          </ul>
        `;

        subscribeLabelWrap.appendChild(infoContainer);
      }
    });
      
// Corrige precio con 40% OFF sin tocar el precio tachado
document.querySelectorAll('.single_case').forEach(function(caseEl) {
  const originalDisplayText = caseEl.querySelector('.single_case_txt p')?.innerHTML;
  if (!originalDisplayText) return;

  // Extrae el precio tachado (el original)
  const regex = /\$(\d+(\.\d+)?)/g;
  const prices = [...originalDisplayText.matchAll(regex)];
  if (prices.length < 2) return;

  const originalPrice = parseFloat(prices[0][1]); // precio tachado: $36.00
  const correctedPrice = (originalPrice * 0.6).toFixed(2); // 40% OFF = 60%

  // Solo reemplaza el segundo valor (el precio con descuento)
  const priceTextEl = caseEl.querySelector('.single_case_txt p');
  if (priceTextEl) {
    priceTextEl.innerHTML = originalDisplayText.replace(prices[1][0], `$${correctedPrice}`);
  }

  // También corrige el data-price para cálculo funcional
  caseEl.setAttribute('data-price', correctedPrice);
});


      
    function getElement(element){
      return document.querySelector(element);
    }

    function convertToShopifyPrice(price) {
    // Convert price to a number
    const numericPrice = parseFloat(price);
  
    // Check if the price is a valid number
    if (isNaN(numericPrice)) {
      return "Invalid price";
    }
  
    // Format the price using toLocaleString()
    const formattedPrice = numericPrice.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  
    return formattedPrice;
  }
      
    const allRcOptions = document.querySelectorAll(".rc-template__button-group .rc-radio.rc_widget__option input");
    const activeButton = getElement(".rc-template__button-group .rc-radio.rc-option--active input");
    const cartButton = getElement(".shopify-product-form button[name='add']");
    // const cartButtonText = cartButton.querySelector("[data-add-to-cart-text]").getAttribute("data-default-text");
    const cartButtonText = cartButton.getAttribute("data-add-text");
    const saveElement = document.createElement("span");
    saveElement.classList.add('savePrice');
      
    if(activeButton.value == "subsave"){
      changeButton("Subscribe now",true);
    }

    function changeButton(buttonText,saveAvailable){
      if(!cartButton.hasAttribute('disabled')){
        cartButton.innerText = buttonText;
      }
      if(saveAvailable){
        const subTotalText = getElement(".rc-option__subsave span[data-price-subsave]")?.innerText.replace("$","");
        let subTotalPrice = Number(subTotalText);
        if(subTotalPrice){
          const activeCaseValue = document.querySelector(".single_case.active")?.getAttribute("data-price");
          if(activeCaseValue){
            subTotalPrice = subTotalPrice + Number(activeCaseValue);
          }
          saveElement.innerText = convertToShopifyPrice(subTotalPrice);
        }
        // saveElement.innerText = getElement(".rc-option__subsave span[data-price-subsave]")?.innerText;
        cartButton.insertAdjacentElement('beforeend',saveElement);
      }else{
        cartButton.querySelector('.savePrice')?.remove();
      }
    }

    if(allRcOptions.length > 0){
      allRcOptions.forEach(function(e){
        e.addEventListener("change",function(){
          if(this.value == "subsave"){
            changeButton("Subscribe now",true);
          }else{
            changeButton(cartButtonText,false);
          }
        });
      })                                                                                                                                                                                                                             
    }

   /*****CASES BUTTON TRIGGER****/
    $('.btn-box').click(function () {
      $(this).parents(".case_selection").find(".single_case.active").removeClass("active");
      $(this).parents(".case_selection").find(".btn-box.active").removeClass("active");
      $(this).parents('.casbox').find('.single_case').addClass('active');
      $(this).addClass('active');
      changeButton("Subscribe now",true);
    })

    /****CASES IMAGE TRIGGERS***/
    const caseTrigger = document.querySelectorAll(".single_case");
    if(caseTrigger.length > 0){
      caseTrigger.forEach(function(e){
        e.addEventListener("click",function(){
          this.closest(".case_selection").querySelector('.single_case.active')?.classList.remove('active');
          this.classList.add('active');
          this.closest(".case_selection").querySelector(".btn-box.active")?.classList.remove('active');
          this.closest(".casbox").querySelector(".btn-box").classList.add("active");
          changeButton("Subscribe now",true);
        })
      })
    }

    /******START: GIFT PRODUCT FUNCTIONALITY*****/
    const gift_products = document.querySelectorAll(".gift-imges .variantImage");
    if(gift_products.length > 0){
      gift_products.forEach(function(e){
        e.addEventListener("click",function(){
          this.closest(".gift-imges").querySelector(".variantImage.active")?.classList.remove("active");
          this.classList.add("active");
        })
      })
    }
    /*****END: GIFT PRODUCT FUNCTIONALITY*****/
      
    /*****Capture variant change for cart button text change****/
    // const variantSelector = document.querySelector("form.shopify-product-form input[name='id']");
    //   if(variantSelector){
    //     variantSelector.addEventListener("change",function(){
    //       setTimeout(function(){
    //         const againActiveButton = getElement(".rc-template__button-group .rc-radio.rc-option--active input");
    //         if(againActiveButton.value == "subsave"){
    //           changeButton("Subscribe now",true);
    //         }else{
    //           changeButton(cartButtonText,false);
    //         }
    //       },2000)
    //     })
    //   }
    },1200);
  });

  /******BELOW IS THE PRODUCT PAGE COMPARTMENT BOXES CODING*******/
  
  /***CLEAR CART ONLOAD***/
if (sessionStorage.getItem("bundleToken") != null) {
  var token=sessionStorage.getItem("bundleToken");
  $.ajax({
    type: 'POST',
    url: '/cart/clear.js',
    data: {
      token: token
    },
    dataType: 'json',
    success: function(response) {
      
      sessionStorage.removeItem('bundleToken');
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.querySelector("#cart-icon-bubble .cart-count-bubble")?.remove();
    }
  });
}
  const giftBox = document.querySelector(".gift_compartment_box");
  if(giftBox){
    function waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }
  
          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
              }
          });
  
          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
    }
    waitForElm('.rc-widget .rc-radio-group__options input.rc-radio__input').then((elm) => {
      const radioTrigger = document.querySelectorAll(".rc-widget .rc-radio-group__options input.rc-radio__input");
      if(radioTrigger.length > 0){
        function checkValue(){
          const selectedValue = document.querySelector(".rc-widget .rc-radio-group__options input.rc-radio__input:checked");
          const selectedInputValue = selectedValue.value;
          if(selectedInputValue == "subsave"){
            giftBox.classList.add("active");
          }
          else{
            giftBox.classList.remove("active");
          }
        }
        checkValue();
        radioTrigger.forEach(function(e){
          e.addEventListener("change",function(){
            checkValue();
          })
        })
      }

    });
    
  }


  document.addEventListener('ajaxProduct:added',function(){
    if(subscription_selected){
      document.body.classList.add("bodyDisabled");
      setTimeout(function(){
        jQuery.getJSON('/cart.js', function(cart) {
          // console.log(cart);
          sessionStorage.setItem("bundleToken", cart.token);
          location.href = "/checkout";
        });
      },1000)
      
    }else{
      actionTrigger.style.pointerEvents = "unset";
    }
  })

  let subscription_selected = false;
  const actionForm = document.querySelector("form.shopify-product-form");
  const actionTrigger = document.querySelector("form.shopify-product-form button[name='add']:not(.disabled,[disabled])");
  if(actionTrigger){
    let counter = 0;
    function setCounter(){
      setTimeout(function(){
        counter = 0;
      },200);
    }
    actionTrigger.addEventListener('click',function(event){
      var element = document.querySelector('.rc-widget .rc-radio-group__options input.rc-radio__input');

if (element !== null) {
      if(counter == 0){
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      const selectedValue = document.querySelector(".rc-widget .rc-radio-group__options input.rc-radio__input:checked");
      const selectedInputValue = selectedValue.value;
      if(selectedInputValue == "subsave"){
        subscription_selected = true;

        /*********START: FREE GIFT SENDING CODING*******/
        const giftContainer = document.querySelector(".sec_1_right_item3 .gift_container .variantImage.active");
        if(giftContainer){
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              cache: false,
              async: false,
              quantity: 1,
              id: Number(giftContainer.getAttribute("data-variant")),
            },
            dataType: "json",
            success: function (data) {
              compartmentSend();
            },
            error: function(){
              compartmentSend();
            },
          });
        }else{
          compartmentSend();
        }
        /*******END: FREE GIFT SENDING CODING******/
        function compartmentSend(){
          const activeCase = document.querySelector(".case_selection .single_case.active");
          if(activeCase){
            const variantId = Number(activeCase.getAttribute("data-variant"));
            actionTrigger.style.pointerEvents = "none";
            let formData = {
             'items': [{
              'id': variantId,
              'quantity': 1
              }]
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
              actionTrigger.style.pointerEvents = "unset";
              counter = 1;
              actionTrigger.click();
              setCounter();
              actionTrigger.style.pointerEvents = "none";
            })
            .catch((error) => {
              console.error('Error:', error);
            });
            
          }
          else{
            counter = 1;
            actionTrigger.click();
            setCounter();
          }
        }
      }
      else{
        counter = 1;
        actionTrigger.click();
        setCounter();
      }
    }
    }
                                   
    })
  }
  if(actionForm){
    actionForm.addEventListener("submit",function(event){
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    });
  }
  
})();